import DOMPurify from "dompurify";
import { FormattedMessage } from "react-intl";
import { Loader } from "~/components/Loader";
import { useLegalDocument } from "~/hooks/useLegalDocument";

interface LegalDocumentProps {
  type: "terms" | "privacy-policy";
}

export const LegalDocument = ({ type }: LegalDocumentProps) => {
  const { data: html, isLoading, isError } = useLegalDocument(type);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader />
      </div>
    );
  }

  if (isError || !html) {
    return (
      <div className="py-8 text-center text-sm text-muted-foreground">
        <FormattedMessage id="legal.loadError" />
      </div>
    );
  }

  return (
    <div
      className="prose prose-sm dark:prose-invert max-w-none overflow-y-auto"
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
    />
  );
};
